module.exports = __webpack_public_path__ + "static/blue-cross-blue-shield-logo-vector-966f0daa3f82d6fcee6e35c1191505a7.png";